var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pa-20px card-item sumar-item",
      class: _vm.odoslanyNaSchvalenie ? "sumar-item-odoslany" : "",
      on: { click: _vm.select }
    },
    [
      _c("v-overlay", {
        attrs: {
          absolute: true,
          opacity: "0.5",
          color: this.$vuetify.theme.dark ? "#2C2E34" : "#FFFFFF",
          value: !_vm.value.enabled,
          "z-index": 1
        }
      }),
      _vm.showStav
        ? _c(
            "div",
            { staticClass: "mb-10px", staticStyle: { "z-index": "1" } },
            [
              _c(
                "status",
                {
                  attrs: { state: _vm.mapColor(_vm.value.id_farby), custom: "" }
                },
                [
                  _vm._v(_vm._s(_vm.value.stav)),
                  _vm.jeDealer && (_vm.value.iur || _vm.value.poznamka)
                    ? [
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              top: "",
                              "close-delay": 0,
                              "open-delay": 200
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass:
                                              "btn-help poznamka-icon",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.$emit(
                                                  "nastavPoznamku",
                                                  _vm.value
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-alert-circle ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3274199168
                            )
                          },
                          [_c("span", [_vm._v("Poznámka")])]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.row
        ? [
            _c("div", { staticClass: "d-flex" }, [
              _vm.showArrow
                ? _c(
                    "div",
                    { staticClass: "sumar-item-arrow-color pr-4" },
                    [
                      _c(
                        "v-icon",
                        {
                          class: { "rotate-180": _vm.showMoreItems },
                          staticStyle: { "z-index": "1" },
                          on: { click: _vm.toggleShowMore }
                        },
                        [_vm._v("mdi-chevron-down")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  class: { "pl-10": !_vm.showArrow }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex text-group-size" },
                    [
                      _vm.value.nazov_produktu != null
                        ? _c("text-group", {
                            staticClass: "pr-16px",
                            attrs: {
                              utext: _vm.value.druh_financovania,
                              btext: _vm.value.nazov_produktu,
                              smallHeader: "",
                              large: ""
                            }
                          })
                        : _vm._e(),
                      _vm.value.akontacia_perc != null
                        ? _c("text-group", {
                            staticClass: "px-16px",
                            attrs: {
                              utext: "Akontácia",
                              btext:
                                _vm.value.akontacia_perc >= 0
                                  ? _vm.value.akontacia_perc.toSkString()
                                  : "",
                              smallHeader: ""
                            }
                          })
                        : _vm._e(),
                      _vm.value.platba_pri_podpise != null
                        ? _c("text-group", {
                            staticClass: "px-16px",
                            attrs: {
                              utext: "Platba pri podpise",
                              btext:
                                _vm.value.platba_pri_podpise >= 0
                                  ? _vm.value.platba_pri_podpise.toEurString()
                                  : "",
                              smallHeader: ""
                            }
                          })
                        : _vm._e(),
                      _vm.value.tenor != null
                        ? _c("text-group", {
                            staticClass: "px-16px",
                            attrs: {
                              utext: "Dĺžka splácania",
                              btext:
                                _vm.value.tenor >= 0
                                  ? _vm.value.tenor.formatSuffix(" mesiacov")
                                  : "",
                              smallHeader: ""
                            }
                          })
                        : _vm._e(),
                      _vm.value.splatka != null
                        ? _c("text-group", {
                            staticClass: "pl-16px",
                            attrs: {
                              utext: "Splátka",
                              btext:
                                _vm.value.splatka >= 0
                                  ? _vm.value.splatka.toEurString()
                                  : "",
                              smallHeader: ""
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.showMoreItems
                    ? _c(
                        "div",
                        { staticClass: "d-flex pt-2 text-group-size" },
                        [
                          _vm.value.vyska_uveru != null
                            ? _c("text-group", {
                                staticClass: "pr-16px",
                                attrs: {
                                  utext: "Celková výška spotrebiteľského úveru",
                                  btext:
                                    _vm.value.vyska_uveru >= 0
                                      ? _vm.value.vyska_uveru.toEurString()
                                      : "",
                                  smallHeader: ""
                                }
                              })
                            : _vm._e(),
                          _vm.value.celkova_suma != null
                            ? _c("text-group", {
                                staticClass: "px-16px",
                                attrs: {
                                  utext:
                                    "Celková čiastka hradená spotrebiteľom",
                                  btext:
                                    _vm.value.celkova_suma >= 0
                                      ? _vm.value.celkova_suma.toEurString()
                                      : "",
                                  smallHeader: ""
                                }
                              })
                            : _vm._e(),
                          _vm.value.klientsky_urok != null
                            ? _c("text-group", {
                                staticClass: "px-16px",
                                attrs: {
                                  utext: "Klientsky úrok",
                                  btext:
                                    _vm.value.klientsky_urok >= 0
                                      ? _vm.value.klientsky_urok.toPercentString()
                                      : "",
                                  smallHeader: ""
                                }
                              })
                            : _vm._e(),
                          _vm.value.rpmn != null
                            ? _c("text-group", {
                                staticClass: "pl-16px",
                                attrs: {
                                  utext: "RPMN",
                                  btext:
                                    _vm.value.rpmn >= 0
                                      ? _vm.value.rpmn.toPercentString()
                                      : "",
                                  smallHeader: ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm.value.poznamka != null
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex pt-6px ml-auto pr-3",
                      staticStyle: { "z-index": "2" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "bold sumar-item-arrow-color",
                          staticStyle: {
                            "font-size": "15px",
                            "white-space": "nowrap"
                          },
                          on: { click: _vm.openSuhlasDialog }
                        },
                        [
                          _vm._v(" Súhlas s podmienkami "),
                          _c("v-icon", [_vm._v("mdi-chevron-right")])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { class: { "ml-auto": _vm.value.poznamka == null } },
                [
                  _vm.pravoNaAdresnuPonuku
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-secondary",
                          attrs: { disabled: !_vm.value.enabled_schvalenie },
                          on: { click: _vm.odoslatNaSchvalenie }
                        },
                        [_vm._v("Odoslať na schválenie")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        : [
            _c("text-group", {
              staticClass: "mt-10px variant-nazov",
              attrs: {
                utext: _vm.value.druh_financovania,
                btext: _vm.value.nazov_produktu,
                smallHeader: "",
                large: ""
              }
            }),
            !_vm.value.olfs
              ? [
                  _c(
                    "div",
                    { staticClass: "d-flex mt-12px" },
                    [
                      _c("text-group", {
                        staticClass: "w50",
                        attrs: {
                          utext: "Akontácia %",
                          btext:
                            _vm.value.akontacia_perc >= 0
                              ? _vm.value.akontacia_perc.toSkString()
                              : "",
                          smallHeader: ""
                        }
                      }),
                      _vm.value.platba_pri_podpise != null
                        ? _c("text-group", {
                            staticClass: "w50",
                            attrs: {
                              utext: "Platba pri podpise",
                              btext:
                                _vm.value.platba_pri_podpise >= 0
                                  ? _vm.value.platba_pri_podpise.toEurString()
                                  : "",
                              smallHeader: ""
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-8px" })
                ]
              : _vm._e(),
            _c(
              "div",
              { staticClass: "d-flex flex-grow-1" },
              [
                _c("text-group", {
                  staticClass: "w50",
                  attrs: {
                    utext: "Dĺžka splácania",
                    btext: _vm.value.tenor.getTenor(),
                    smallHeader: ""
                  }
                }),
                _vm.value.splatka != null
                  ? _c("text-group", {
                      staticClass: "w50",
                      attrs: {
                        utext: "Splátka",
                        btext:
                          _vm.value.splatka >= 0
                            ? _vm.value.splatka.toEurString()
                            : "",
                        smallHeader: ""
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm.value.olfs
              ? [
                  _c("v-divider", { staticClass: "my-8px" }),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-grow-1" },
                    [
                      _c("text-group", {
                        staticClass: "w100",
                        attrs: {
                          utext: "Nájazd",
                          btext: _vm.value.najazd,
                          smallHeader: ""
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "w100",
                          staticStyle: {
                            "text-align": "end",
                            "align-content": "center"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit(
                                    "openPorovnanieBalikovDialog"
                                  )
                                }
                              }
                            },
                            [_vm._v(" $detail_zmluvy ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : [
                  _c("v-divider", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.value.zv_spl_koniec_suma,
                        expression: "value.zv_spl_koniec_suma"
                      }
                    ],
                    staticClass: "my-8px"
                  }),
                  _c("text-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.value.zv_spl_koniec_suma,
                        expression: "value.zv_spl_koniec_suma"
                      }
                    ],
                    staticClass: "mt-2 white100",
                    staticStyle: { "text-align": "center" },
                    attrs: {
                      utext: "Posledná zvýšená splátka (%/suma)",
                      btext: _vm.value.zv_spl_koniec_suma
                        ? _vm.value.zv_spl_koniec_perc.toPercentString(2) +
                          "/" +
                          _vm.value.zv_spl_koniec_suma.toEurString()
                        : "",
                      smallHeader: ""
                    }
                  }),
                  _c("v-divider", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.value.zost_hodnota_suma,
                        expression: "value.zost_hodnota_suma"
                      }
                    ],
                    staticClass: "my-8px"
                  }),
                  _c("text-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.value.zost_hodnota_suma,
                        expression: "value.zost_hodnota_suma"
                      }
                    ],
                    staticClass: "mt-2 white100",
                    staticStyle: { "text-align": "center" },
                    attrs: {
                      utext: "Zostatková hodnota (%/suma)",
                      btext: _vm.value.zost_hodnota_suma
                        ? _vm.value.zost_hodnota_perc.toPercentString(2) +
                          "/" +
                          _vm.value.zost_hodnota_suma.toEurString()
                        : "",
                      smallHeader: ""
                    }
                  }),
                  _c("v-divider", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    staticClass: "my-8px"
                  }),
                  _c("text-group", {
                    staticClass: "mt-2 white100",
                    staticStyle: { "text-align": "center" },
                    attrs: {
                      utext: "Celková cena leasingu s DPH",
                      btext:
                        _vm.value.lo_s_dph >= 0
                          ? _vm.value.lo_s_dph.toEurString()
                          : "",
                      smallHeader: "",
                      hidden: ""
                    }
                  }),
                  _vm.formaPodnikania.pkId == 3
                    ? [
                        _c("v-divider", { staticClass: "my-8px" }),
                        _c("text-group", {
                          staticClass: "mt-2 white100",
                          staticStyle: { "text-align": "center" },
                          attrs: {
                            utext: "Celková výška spotrebiteľského úveru",
                            btext:
                              _vm.value.vyska_uveru >= 0
                                ? _vm.value.vyska_uveru.toEurString()
                                : "",
                            smallHeader: ""
                          }
                        }),
                        _c("v-divider", { staticClass: "my-8px" }),
                        _c("text-group", {
                          staticClass: "mt-2 white100",
                          staticStyle: { "text-align": "center" },
                          attrs: {
                            utext: "Celková čiastka hradená spotrebiteľom",
                            btext:
                              _vm.value.celkova_suma >= 0
                                ? _vm.value.celkova_suma.toEurString()
                                : "",
                            smallHeader: ""
                          }
                        })
                      ]
                    : _vm._e()
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }